<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('twins.detail') }}</span>
  </template>

  <v-treeview v-if="item.snapshot" :items="treeItem"></v-treeview>

  <v-layout v-else style="min-height:100px">
    <span class="centerized title grey--text text-xs-center">{{ $t('twins.no_detail_available') }}</span>
  </v-layout>

  <template slot="actions">
    <v-btn v-if="!backuping" :disabled="backuping" flat color="secondary" @click="$emit('delete',item)">{{ $t('twins.delete') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn v-if="backuping" :disabled="!backuping" flat color="accent" @click="$emit('cancel',item['.key'])">{{ $t('twins.cancel') }}</v-btn>
    <v-btn v-else :disabled="backuping" flat color="primary" @click="$emit('restore',item)">{{ $t('twins.restore') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'

export default {
  name: 'TwinsDetailDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  },
  components: {
    'standard-dialog': Dialog
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    backuping() {
      return this.item.name == '0';
    },
    targetName() {
      let ss = this.item.snapshot || {};
      let list = []
      Object.keys(ss.targetName || {}).forEach(dk => {
        Object.keys(ss.targetName[dk]).forEach(ck => {
          let n = ss.targetName[dk][ck];
          list.push({
            id: `${dk}-${ck}: ${n}`,
            name: `${dk}-${ck}: ${n}`
          });
        });
      });
      return list;
    },
    device() {
      let ss = this.item.snapshot || {};
      let list = [];
      Object.keys(ss.device || {}).map(dk => {
        let d = ss.device[dk];
        Object.values(d.channel || {}).forEach(c => {
          list.push({
            id: `${d.uid}-${c.cid}`,
            name: `${d.uid}-${c.cid}: ${c.name}`
          });
        });
      });
      return list;
    },
    macro() {
      let ss = this.item.snapshot || {};
      return (ss.macro || []).map(m => {
        return {
          id: m.title,
          name: m.title
        }
      });
    },
    scene() {
      let ss = this.item.snapshot || {};
      return (ss.scene || []).map(s => {
        return {
          id: s.title,
          name: s.title
        }
      });
    },
    treeItem() {
      return [{
        id: 0,
        name: this.$t('twins.target_name'),
        children: this.targetName
      }, {
        id: 1,
        name: this.$t('twins.device'),
        children: this.device
      }, {
        id: 2,
        name: this.$t('twins.macro'),
        children: this.macro
      }, {
        id: 3,
        name: this.$t('twins.scene'),
        children: this.scene
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/twins/TwinsDetailDialog.vue